module.exports = __webpack_public_path__ + "static/img/logo.bf8b9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1